




























































































import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator';
import { IRules } from '@/components/UI/Form/ValidationModule';
import { validateRequired, validateType } from '@/components/UI/Form/Validations';
import i18n from '@/i18n';
import { DocumentNode } from 'graphql';
import { StopActivatingPopup } from '@/decorators/stopPopupActive';

@Component
export default class MailButton extends Vue {
  @Prop({ type: String, required: false }) private recipient!: string;
  @Prop({ type: Array, required: true}) private copies!: string[];
  @Prop({ type: Object, required: true }) private mutation!: DocumentNode;
  @Prop({ type: Function, required: true }) private variables!: (variables: string[]) => unknown;
  @Prop({ type: String, required: false}) private title!: string
  @Prop({ type: String, required: true}) private popupTitle!: string
  @Prop({ type: String, required: false}) private helpName?: string
  @Prop({ type: String, default: 'standard' }) private color!: string;

  private innerRecipient = this.recipient;
  private innerCopies = [ ...this.copies ];

  @Watch('recipient')
  @Watch('copies')
  private setInnerValues() {
    this.innerRecipient = this.recipient;
    this.innerCopies = [ ...this.copies ];
  }

  public validForm = true;
  public showEmailDialog = false;

  public rules: IRules = {
    recipient: [
      {
        validation: validateRequired(),
        message: i18n.t('Error.required', { field: i18n.t('Document.Email.recipient') }),
      },
      {
        validation: validateType('email'),
        message: i18n.t('Error.email'),
      },
    ],
    copy: [
      {
        validation: validateRequired(),
        message: i18n.t('Document.Email.validateCopy'),
      },
      {
        validation: validateType('email'),
        message: i18n.t('Error.email'),
      },
    ],
  }

  public addCopy(email = '') {
    const index = this.innerCopies.length;
    if (index > 9) {
      this.$sMessage.warning(i18n.t('Document.Email.addCopyMax'));
      return;
    }

    this.innerCopies.push(email);
  }

  public removeCopy(index: number) {
    this.innerCopies.splice(index, 1);
  }

  @StopActivatingPopup()
  //this is done to prevent opening list
  //of sent notices on Overdue notices on Invoice page
  @Emit('dialog-opened')
  public openEmailDialog() {
    this.open();
  }

  // Lets a parent open the dialog without a click, e.g. right after the
  // document to send has been written.
  public open() {
    this.showEmailDialog = true;
  }

  public sendMail() {
    const adresses = [
      this.innerRecipient,
      ...this.innerCopies,
    ];

    this.$sMessage.info(i18n.t('Document.Email.sending'));

    this.$apollo.mutate({
      mutation: this.mutation,
      variables: this.variables(adresses),
    }).then(({data}) => {
      this.$emit('sent', data);
    });
  }
}
